module.exports = __webpack_public_path__ + "img/marketing.ff7b34bf.png";